var render, staticRenderFns
import script from "./RenderDetailItem.vue?vue&type=script&lang=js"
export * from "./RenderDetailItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c4a58c",
  null
  
)

export default component.exports